import { Box, Icon, Link, Typography } from '@mui/material'
import { useMutation, useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { getCredit, payWithCredit } from 'services/api/modules/recruitment/order'
import AdxButton from 'components/custom/AdxButton'

const SummaryCart = ({ candidate, selectedCart, totalPrice }) => {
  const navigate = useNavigate()
  const goToCreditTopUp = () => {
    navigate('/app/recruitment/credit/top-up')
  }
  // call api
  const {
    isLoading: creditBalanceIsLoading,
    error: creditBalanceError,
    data: creditBalanceData,
  } = useQuery(
    ['getCredit'],
    async () => {
      const { data } = await getCredit()
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )
  console.log('🚀 ~ SummaryCart ~ creditBalanceData:', creditBalanceData)

  const {
    mutate: payWithCreditMutate,
    isSuccess: payWithCreditIsSuccess,
    isLoading: payWithCreditIsLoading,
  } = useMutation((value) => payWithCredit(value), {
    onSuccess: (response) => {
      navigate('/app/recruitment/payment/candidate-purchased/success', {
        state: {
          data: response,
        },
      })
    },

    onError: (error) => {
      console.log('here', error)
      //  navigate('/app/recruitment/payment/candidate-purchased/fail',{
      //     state:{
      //       data:error
      //     }
      //   })
    },
  })

  const handlePayment = () => {
    payWithCreditMutate({
      current_balance: creditBalanceData?.current_balance,
      total_price: totalPrice,
      selected_cart_ids: selectedCart,
    })
  }

  const Testing = () => {
    ;<Typography
      onClick={() =>
        window.open(
          'https://adnexio-hr-prod.s3.ap-southeast-1.amazonaws.com/terms_and_conditions/topup_service/topup_tnc_20230223.pdf',
          '_blank'
        )
      }
      variant="body2"
      color="alternate.main"
      sx={{
        textDecoration: 'underline',
        cursor: 'pointer',
      }}
    >
      {' '}
      Terms and Conditions
    </Typography>
  }

  return (
    <Box
      marginTop={8}
      sx={{
        maxHeight: 700,
        //   overflow:"auto",
        borderRadius: '10px',
        width: '30%',
        backgroundColor: 'white.main',
        position: 'fixed',
      }}
    >
      <Box marginTop={4}>
        <Typography px={2} component="span" variant="h4" color="dark-text.main">
          Summary
        </Typography>
      </Box>
      <Box marginTop={2} px={2} display="flex" justifyContent="space-between">
        <Typography variant="body1" color="light-gray-text.main">
          {candidate} candidates
        </Typography>
        <Typography variant="body1" color="light-gray-text.main">
          {' '}
          RM {totalPrice || '0'}.00
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        padding={2}
        sx={{
          width: '100%',
          borderTop: '1px solid',
          borderColor: 'gray-line.main',
        }}
      >
        <Typography variant="body1" color="light-gray-text.main">
          Subtotal
        </Typography>
        <Typography variant="body1" color="light-gray-text.main">
          RM {totalPrice || '0'}.00
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" marginTop={2} px={2}>
        <Typography
          marginTop={2}
          variant="subtitle1"
          color="dark-text.main"
          sx={{
            fontWeight: 'bold',
          }}
        >
          TOTAL
        </Typography>
        <Typography
          marginTop={2}
          variant="subtitle1"
          color="dark-text.main"
          sx={{
            fontWeight: 'bold',
          }}
        >
          {' '}
          RM {totalPrice || 0}.00
        </Typography>
      </Box>

      {creditBalanceData?.current_balance >= totalPrice &&
      creditBalanceData?.current_balance !== undefined ? (
        <Box sx={{ width: '100%' }} px={2}>
          <Box
            marginTop={2}
            padding={2}
            display="flex"
            alignItems="center"
            sx={{
              border: '1px solid',
              borderColor: 'gray-line.main',
              borderRadius: 1,
            }}
          >
            <Box
              width={45}
              height={45}
              borderRadius="50%"
              bgcolor="default-background.main"
              marginRight={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                sx={{
                  color: 'light-gray-text.main',
                }}
              >
                wallet_icon
              </Icon>
            </Box>
            <Box>
              <Typography variant="body1" color="light-gray-text.main">
                Available credit
              </Typography>
              <Typography variant="subtitle1" color="dark-text.main">
                RM {creditBalanceData?.current_balance ?? 0}
              </Typography>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box>
          <Box sx={{ width: '100%' }} px={2}>
            <Box
              marginTop={2}
              padding={2}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                border: '1px solid',
                borderColor: 'error.main',
                borderRadius: 1,
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: '100%' }}
              >
                <Box display="flex" alignItems="center">
                  <Box
                    width={45}
                    height={45}
                    borderRadius="50%"
                    bgcolor="default-background.main"
                    marginRight={2}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon
                      sx={{
                        color: 'light-gray-text.main',
                      }}
                    >
                      wallet_icon
                    </Icon>
                  </Box>
                  <Box>
                    <Typography variant="body1" color="light-gray-text.main">
                      Available credit
                    </Typography>
                    <Typography variant="subtitle1" color="dark-text.main">
                      RM {creditBalanceData?.current_balance ?? 0}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <AdxButton
                    variant={'outlined'}
                    onClick={goToCreditTopUp}
                    size="small"
                    sx={{ width: 100 }}
                  >
                    <Icon>add_icon</Icon> Topup
                  </AdxButton>
                </Box>
              </Box>
            </Box>
          </Box>
          <Typography px={2} mt={2} variant="body2" color="error.main">
            Your credit is insufficient
          </Typography>
        </Box>
      )}

      <Box mt={2} sx={{ width: '100%' }} px={2}>
        <AdxButton
          variant={'contained'}
          disabled={
            creditBalanceData?.current_balance < totalPrice || selectedCart.length === 0
              ? true
              : false
          }
          size="standard"
          sx={{ width: '100%' }}
          isLoading={payWithCreditIsLoading}
          onClick={handlePayment}
        >
          Checkout
        </AdxButton>
      </Box>
      <Box display="flex" columnGap={0.5} mb={4} mt={2} px={2} justifyContent="center">
        <Typography
          textAlign="center"
          variant="body2"
          color="light-gray-text.main"
          components={{
            // Use a span element for the first part of the text
            span: { children: 'By proceeding, you agree with our ' },
            // Use an anchor element for the terms and conditions link
            a: {
              children: 'Terms and Conditions',
              href: 'https://adnexio-hr-prod.s3.ap-southeast-1.amazonaws.com/terms_and_conditions/topup_service/topup_tnc_20230223.pdf',
              target: '_blank',
              rel: 'noopener noreferrer',
              sx: {
                color: 'alternate.main',
                textDecoration: 'underline',
                cursor: 'pointer',
              },
            },
            // Use a span element for the 'and' text
            span2: { children: ' and ' },
            // Use an anchor element for the privacy policy link
            a2: {
              children: 'Privacy Policy',
              href: 'https://adnexio.jobs/privacy-policy',
              target: '_blank',
              rel: 'noopener noreferrer',
              sx: {
                color: 'alternate.main',
                textDecoration: 'underline',
                cursor: 'pointer',
              },
            },
          }}
        >
          By proceeding, you agree with our{' '}
          <Link
            href="https://adnexio-hr-prod.s3.ap-southeast-1.amazonaws.com/terms_and_conditions/topup_service/topup_tnc_20230223.pdf"
            target="_blank"
            rel="noopener noreferrer"
            color="alternate.main"
            underline="always"
            sx={{ cursor: 'pointer' }}
          >
            Terms and Conditions
          </Link>
          {' and '}
          <Link
            href="https://adnexio.jobs/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            color="alternate.main"
            underline="always"
            sx={{ cursor: 'pointer' }}
          >
            Privacy Policy
          </Link>
        </Typography>
      </Box>
    </Box>
  )
  // }
}
export default SummaryCart
